import Vue from 'vue'
import CryptoJS from 'crypto-js'



export default  {
// needed to set up as plugin, used by Vue to make it global in main
  install: function(Vue) {
    Object.defineProperty(Vue.prototype, '$crypto', { value: this });
  },
  salt :"ociparamlock",
  salt2:"IVr+xmoTP3tLHV7f8fy6qxpNakA0AXjnW7+hHbkW5T651yHsFpo5VkTtHCGwRNYW/B16X3lBiPtxwSH6tnvHJg==",
  encodeSample : "ZtpEcJhqyW",
   encryptParam :function(param){
    if(param !== null && param !== undefined && param !== ''){
      let encryptedParam = CryptoJS.AES.encrypt(param, this.salt)
      return encodeURIComponent(encryptedParam.toString());
    }else{
      return false;
    }
  },
  decryptParam :function (param) {
    if(param !== null && param !== undefined && param !== ''){

      var bytes = CryptoJS.AES.decrypt(decodeURIComponent(param).toString(), this.salt);
      return bytes.toString(CryptoJS.enc.Utf8);

    }else{
      return false;
    }
  },
  encryptData: function(data){
   return CryptoJS.AES.encrypt(data, this.salt2)
  },
  decryptData: function(data) {
    var bytes  = CryptoJS.AES.decrypt(data.toString(), this.salt2)
    return bytes.toString(CryptoJS.enc.Utf8);
  },

  //using encoding instead of encrypting (to make Jon happy)

  encodeIdParam :function(param){
    let paramInt = parseInt(param);
    if(Number.isInteger(paramInt)){
       let generatedNum = ((2*paramInt) +6378264598).toString();
       let code ="";
      //build new value from encodeString
      for(let i=0; i<generatedNum.length;i++){
        let num = Number(generatedNum.charAt(i));
          code+=this.encodeSample.charAt(num)
      }
      return code;
    }else{
      return false;
    }
  },
  decodeIdParam :function (param) {
    if(param !== null && param !== undefined && param !== ''){
      let decodedNumString ="";
      //build new value from encodeString
      //console.log("PARAM length"+param.length)
      for(let i=0; i<param.length;i++){
        let charVal = param.charAt(i);
       // console.log("Character value "+ charVal)
        decodedNumString+=this.encodeSample.indexOf(charVal)
       // console.log(decodedNumString)
      }
      let numBeforeEncoding = Number(decodedNumString);
      let id = ((numBeforeEncoding -6378264598) /2)
      return id;
    }else{
      return false;
    }
  },




  }
